/**
 * Series Dash Style Lookup
 *
 * Maps a chart series' semantic role (which line it represents) to its
 * Google Charts `lineDashStyle` value. Used by dual-line charts (e.g. the
 * income_allocations Tax Basis + Formula/Market Value chart) so the choice
 * of which line renders dashed vs solid is driven by what the series means,
 * not by its positional index in `options.series`.
 */

const SeriesRoles = {
	TAX_BASIS: 'taxBasis', // Tax basis line - rendered dashed
	FORMULA_VALUE: 'formulaValue', // Formula/Market Value line - rendered solid (default)
};

const DASH_STYLE_BY_ROLE = {
	[SeriesRoles.TAX_BASIS]: [4, 4],
};

/**
 * Resolve the Google Charts `lineDashStyle` for a given series role.
 * Unrecognized or missing roles fall back to `undefined` (solid line),
 * matching today's implicit default for any series without a lineDashStyle.
 *
 * @param {string} seriesRole - One of SeriesRoles' values.
 * @returns {number[]|undefined} The dash pattern, or undefined for solid.
 */
function getDashStyleForSeriesRole(seriesRole) {
	return DASH_STYLE_BY_ROLE[seriesRole];
}

export { SeriesRoles, DASH_STYLE_BY_ROLE, getDashStyleForSeriesRole };
